export enum DoorHeightEnum {
  Low,
  High,
  None
}
